import { useRef, useEffect } from 'preact/hooks';

import './waves.scss';

import Chop from './chop';

import * as waveAnimation from 'components/swell-preview/utils/wave-animation-calculations';
import assignSwellLetter from 'components/forecast-table/swell-tooltip/swell-letters';

const Waves = props => {
  const css = 'waves';
  const waveRef = useRef();
  const WAVESCONTAINERWIDTH = 240;
  let animateDuration = 0;
  let xPosition = 0;
  let animationDelay = 0;

  if (props.startX > 0) {
    const timePercentage =
      props.startX /
      (waveAnimation.calculateAnimationDuration(props.wavePeriod) /
        props.playbackSpeed);
    const xPercentage = props.startX;
    animateDuration = Math.round(
      waveAnimation.calculateAnimationDuration(props.wavePeriod) /
        props.playbackSpeed -
        timePercentage
    );
    xPosition = WAVESCONTAINERWIDTH - xPercentage - 10;

    if (props.isWaveSheltered) {
      const elapsed = props.startX / WAVESCONTAINERWIDTH;
      animationDelay = elapsed * 10;
      xPosition = xPercentage - 28;
    }
  } else {
    animateDuration =
      waveAnimation.calculateAnimationDuration(props.wavePeriod) /
      props.playbackSpeed;
    xPosition = -10;
  }

  const setWaveAnimation = {
    animationDuration: Math.round(animateDuration) + 's',
    animationName: 'movewave',
    left: `${xPosition}px`,
  };

  const setWaveAnimationSheltered = {
    animationDuration: Math.round(animateDuration) + 's',
    animationName: 'movewavesheltered',
    animationDelay: `-${animationDelay}s`,
    right: `${xPosition}px`,
  };

  const setWaveStyles = {
    transform: `scale(${waveAnimation.calculateWaveWidth(
      props.wavePeriod,
      props.isWaveSheltered
    )}, ${waveAnimation.calculateWaveHeight(props.waveHeight)})`,
    fill: props.waveColor,
  };

  const setWaveStacking = {
    zIndex: (10 - props.waveStacking) * 10,
  };

  useEffect(() => {
    let start = props.startTime;
    start.setSeconds(start.getSeconds());
    const startTime = start.toLocaleTimeString().replace(/:/g, '');

    let end = props.startTime;
    end.setSeconds(end.getSeconds() + Math.round(animateDuration));
    const endTime = end.toLocaleTimeString().replace(/:/g, '');

    if (props.wavePeriod >= 5) {
      props.ampRefs({
        id: props.waveIndex,
        el: waveRef.current,
        start: startTime,
        end: endTime,
        width:
          3.8 *
          waveAnimation.calculateWaveWidth(
            props.wavePeriod,
            props.isWaveSheltered
          ) *
          10,
      });
    }
  }, []);

  return (
    <div
      style={Object.assign(
        props.isWaveSheltered ? setWaveAnimationSheltered : setWaveAnimation,
        setWaveStacking
      )}
      className={`${css}`}
    >
      <div
        className={`${css}__icon-target`}
        id={`wave-icon__${props.waveIndex}`}
      >
        {!props.isWaveSheltered ? (
          <svg
            ref={waveRef}
            style={setWaveStyles}
            className={`${css}__icon`}
            viewBox="0 0 38 72"
            height="72"
            width="38"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polyline points="0.00,72.00 0.86,65.59 2.16,58.63 3.02,54.02 3.61,51.36 4.15,48.63 4.86,44.95 5.61,41.51 6.70,37.21 7.37,34.55 9.02,28.38 10.66,23.37 11.92,19.86 13.37,16.42 14.15,14.23 15.40,11.96 16.19,10.24 17.32,8.05 17.83,7.50 19.17,5.39 20.15,4.46 21.01,3.28 22.18,2.11 23.44,1.33 24.38,0.55 25.48,0.39 26.73,0.00 28.06,0.00 28.85,0.39 29.83,0.78 31.36,1.88 32.14,2.89 33.12,4.61 33.51,5.79 33.87,6.96 34.26,8.05 34.65,9.62 34.85,10.79 35.43,12.74 35.71,15.64 35.04,12.51 34.18,9.46 33.00,7.11 31.28,4.46 30.02,3.44 28.26,3.05 26.73,4.07 25.67,4.85 24.50,6.18 23.05,8.05 21.68,11.34 20.62,16.42 19.95,22.36 19.75,25.09 19.56,28.77 19.95,34.32 20.73,39.32 22.38,45.89 23.64,49.56 24.97,53.08 26.42,55.74 27.99,58.63 29.63,61.37 30.77,62.93 33.39,66.37 36.10,69.50 37.35,70.83 39.00,71.77" />
          </svg>
        ) : (
          <Chop styles={setWaveStyles} />
        )}
      </div>
      {props.wavePeriod >= 5 && (
        <div className={`${css}__swell-index`}>
          {assignSwellLetter(props.waveType)}
        </div>
      )}
    </div>
  );
};

export default Waves;
